export enum IconTheme {
  DARK,
  LIGHT,
}
